<template>
  <div class="operation-page__head">
    <h1>{{ title }}</h1>
    <div v-if="isBizPage" class="operation-page__head-actions">
      <el-dropdown v-if="primaryAction && primaryAction.items" trigger="click">
        <button class="primary-action">
          <el-icon><component :is="primaryIcon" /></el-icon>
          {{ primaryAction.label }}
          <el-icon class="el-icon--right"><ArrowDown /></el-icon>
        </button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-for="item in primaryAction.items" :key="item.label" @click="item.handler">
              {{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <button v-else-if="primaryAction" class="primary-action" @click="primaryAction.handler">
        <el-icon><component :is="primaryIcon" /></el-icon>
        {{ primaryAction.label }}
      </button>
      <button class="secondary-action" @click="$emit('refresh')">
        <el-icon><RefreshRight /></el-icon>
        {{ refreshButtonText }}
      </button>
    </div>
    <button v-else-if="fallbackAction" class="primary-action" @click="$emit('fallbackAction')">
      <el-icon><component :is="fallbackIcon" /></el-icon>
      {{ fallbackAction }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import { ArrowDown, Download, EditPen, Plus, RefreshRight } from '@element-plus/icons-vue'

type OperationHeaderAction = {
  label: string
  icon: 'plus' | 'edit'
  handler: () => void
  items?: Array<{
    label: string
    handler: () => void
  }>
}

const props = defineProps<{
  title: string
  isBizPage: boolean
  primaryAction?: OperationHeaderAction
  refreshButtonText: string
  fallbackAction?: string
  isCreateAction: boolean
}>()

defineEmits<{
  refresh: []
  fallbackAction: []
}>()

const { title, isBizPage, primaryAction, refreshButtonText, fallbackAction, isCreateAction } = toRefs(props)

const primaryIcon = computed(() => primaryAction.value?.icon === 'edit' ? EditPen : Plus)
const fallbackIcon = computed(() => isCreateAction.value ? Plus : Download)
</script>

<style scoped lang="scss">
.operation-page__head { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.operation-page__head-actions { display: flex; align-items: center; gap: 8px; }
.operation-page__head h1 { margin: 0; color: var(--jf-color-text-primary); font-size: 20px; font-weight: 800; }
button { border: 0; cursor: pointer; font: inherit; }
.primary-action { height: 38px; padding: 0 16px; border-radius: 8px; display: inline-flex; align-items: center; gap: 8px; background: var(--jf-color-primary); color: #fff; font-size: 14px; font-weight: 700; transition: background .2s; }
.primary-action:hover { background: var(--jf-color-primary-dark); }
.secondary-action { height: 38px; padding: 0 16px; border: 1px solid var(--jf-color-border); border-radius: 8px; display: inline-flex; align-items: center; gap: 8px; background: #fff; color: var(--jf-color-text-primary); font-size: 14px; font-weight: 700; }
.secondary-action:hover { border-color: var(--jf-color-primary); color: var(--jf-color-primary-dark); }
</style>
